export const openGroup = (dock_id) => {
  let url = `${process.env.REACT_APP_DELEEVADMIN}/livreurs/logs/group/${dock_id}`;
  let options = "menubar=no, status=no, menubar=no, width=600, height=600, name=group";
  window.open(url, 'group', options);

  return false;
};
